import { render } from "./ViewUserTraining.vue?vue&type=template&id=6c7375ec&scoped=true"
import script from "./ViewUserTraining.vue?vue&type=script&lang=js"
export * from "./ViewUserTraining.vue?vue&type=script&lang=js"

import "./ViewUserTraining.vue?vue&type=style&index=0&id=6c7375ec&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c7375ec"]])

export default __exports__